
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinpune() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Pune',
        heading: 'etravo : Corporate Cab and Bus Services in Pune',
        headingDescription: 'eTravo offers professional and reliable Corporate Cab and Bus Services in Pune, supporting businesses with tailored transportation solutions across all major commercial zones. Whether it is executive cabs for meetings, airport transfers, and VIP movements, or corporate buses for daily employee commutes, team outings, and events — our services are designed for comfort, punctuality, and safety. With a fleet of modern vehicles, GPS-enabled tracking, and experienced chauffeurs, eTravo ensures seamless and efficient corporate mobility across Pune.',

        top: 'Top Places to Visit in Pune with etravo',
   "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire. Though much of the fort was destroyed by fire in 1828, the remaining structures, including the massive gates and foundations, offer a glimpse into its majestic past. The site is known for its architectural grandeur and the evening light and sound show that narrates its rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892, the Aga Khan Palace is a significant monument in Indian history. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace is renowned for its Italian arches, sprawling lawns, and the memorials of Gandhi and Kasturba. It now houses a museum dedicated to Gandhi's life and work."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill about 30 km from Pune, Sinhagad Fort is a popular trekking destination. The fort has witnessed several battles, including the famous Battle of Sinhagad in 1670. Visitors can explore the ruins, enjoy panoramic views of the surrounding region, and savor local delicacies like 'pithla bhakri' sold by vendors at the summit."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This temple is one of the most famous Ganesh temples in India. Known for its rich history and the grand Ganesh Festival celebrations, the temple attracts thousands of devotees and tourists annually."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a tranquil haven for those seeking peace and spiritual growth. The ashram offers various meditation programs and workshops in a lush, serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of over 20,000 artifacts, showcasing the everyday life of Indians in the past. From musical instruments and paintings to household items and sculptures, the museum offers a deep dive into India's rich cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features intricate carvings and a unique circular Nandi mandapa. It's a serene spot amidst the bustling city."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill is one of the highest points in Pune, offering a panoramic view of the city. Atop the hill stands the Parvati Temple, dedicated to Goddess Parvati. The hill is a popular spot for morning walks and photography enthusiasts."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as Pu La Deshpande Garden, this is one of the largest Japanese-style gardens outside Japan. Inspired by the 300-year-old Okayama Korakuen Garden, it features manicured lawns, flowing streams, and picturesque bridges."
    },
    {
      "title": "Empress Garden",
      "description": "Spread over 39 acres, Empress Garden is a botanical garden known for its lush greenery, rare flora, and well-maintained lawns. It's a perfect spot for picnics, leisurely walks, and enjoying nature in the heart of the city."
    }
  ],
 "services": [
    {
      "name": "Corporate Travel Solutions Pune",
      "description": "eTravo offers end-to-end corporate travel solutions in Pune tailored to the needs of modern businesses. From daily office commutes to executive transfers and event transportation, our services ensure professionalism, comfort, and punctuality. We cater to startups, SMEs, and large enterprises with scalable options that include cabs, tempo travellers, and AC buses. All vehicles are GPS-enabled, driven by trained professionals, and backed by 24/7 customer support."
    },
    {
      "name": "Office Transport Cabs and Buses in Pune",
      "description": "Streamline employee transportation with eTravo’s office transport services in Pune. We provide well-maintained cabs and buses for daily pickups, drop-offs, and shift-based schedules. Whether your office is in a tech park, industrial area, or corporate hub, we ensure reliable and timely transport with customized plans and transparent billing options."
    },
    {
      "name": "Employee Shuttle Services Pune",
      "description": "eTravo’s employee shuttle services in Pune are ideal for companies seeking efficient group transport solutions. Our shuttle services are designed for operational efficiency with fixed or flexible routes, shift coordination, and live-tracking. With clean, AC vehicles and professional drivers, we help improve staff attendance, morale, and travel convenience."
    },
    {
      "name": "Business Event Transportation Pune",
      "description": "Organizing a corporate event in Pune? eTravo handles all your transport needs—from employee movement to guest pickups and VIP shuttles. We provide luxury cars, tempo travellers, and large buses suitable for seminars, conferences, training sessions, and offsite events. Our experienced team manages scheduling, coordination, and route planning for a seamless event transport experience."
    },
    {
      "name": "AC Bus Rentals for Corporate Clients Pune",
      "description": "eTravo offers air-conditioned bus rentals in Pune for corporate clients who need large-capacity, comfortable transport. Our fleet includes minibuses and full-sized coaches suitable for employee commutes, factory visits, and large group travel. All buses are equipped with modern interiors, safety features, and are operated by experienced drivers ensuring reliability and comfort."
    },
    {
      "name": "Affordable Corporate Cab Hire Pune",
      "description": "Looking for budget-friendly cab solutions for your corporate transport needs in Pune? eTravo provides cost-effective cab hire options without compromising on quality or safety. Choose from hatchbacks, sedans, and SUVs for daily use, one-way transfers, or monthly plans. Our pricing is transparent, and all vehicles are regularly serviced and sanitized."
    },
    {
      "name": "Daily Commute Services for Corporates in Pune",
      "description": "eTravo simplifies daily employee travel in Pune with reliable commute services tailored to business operations. We offer customized transport plans that align with office hours, employee locations, and shift structures. Our daily commute service helps companies boost workforce efficiency while ensuring a stress-free travel experience for staff."
    }
  ],
  "tableData": [
    ["Corporate Travel Solutions Pune", "Office Transport Cabs and Buses in Pune"],
    ["Employee Shuttle Services Pune", "Business Event Transportation Pune"],
    ["AC Bus Rentals for Corporate Clients Pune", "Affordable Corporate Cab Hire Pune"],
    ["Daily Commute Services for Corporates in Pune", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Trusted Partner for Corporate Transport in Pune",
        "WhyChoosedescription": "eTravo is a leading provider of corporate cab and bus services in Pune, catering to IT parks, manufacturing hubs, educational institutions, and MNCs across the city. Whether you’re managing daily commutes or arranging transport for corporate events, we ensure timely, professional, and dependable service every step of the way."
    },
    {
        "WhyChooseheading": "Diverse Fleet for Every Business Need",
        "WhyChoosedescription": "Our fleet in Pune includes executive sedans, SUVs, tempo travellers, and large AC buses. Each vehicle is designed for comfort, with spacious interiors, air conditioning, reclining seats, and real-time tracking—making them ideal for employee transportation, airport pickups, client visits, and more."
    },
    {
        "WhyChooseheading": "Professionally Trained and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are experienced, background-verified, and trained in corporate etiquette. They are well-versed in Pune's traffic and routes, including key areas like Hinjewadi, Magarpatta, Kharadi, and Pimpri-Chinchwad, ensuring timely arrivals and safe, respectful service."
    },
    {
        "WhyChooseheading": "Upfront, Transparent Pricing",
        "WhyChoosedescription": "We offer clear and competitive pricing models suited for startups, SMEs, and large enterprises in Pune. With no hidden charges, flexible billing cycles, and GST-compliant invoices, you can manage your corporate transport expenses efficiently and predictably."
    },
    {
        "WhyChooseheading": "Safe and Hygienic Travel Standards",
        "WhyChoosedescription": "eTravo prioritizes safety and hygiene. All vehicles undergo regular cleaning, sanitization, and safety inspections. GPS tracking, seat belts, emergency kits, and trained drivers ensure every journey is secure—whether it’s a short city ride or long-distance outstation trip."
    },
    {
        "WhyChooseheading": "24/7 Availability for Pune’s Dynamic Business Ecosystem",
        "WhyChoosedescription": "Pune is a city that operates beyond standard business hours. eTravo offers round-the-clock support and transport services, including late-night shift drops, early morning pickups, and last-minute ride requests—making us the ideal partner for BPOs, IT firms, and manufacturing units."
    },
    {
        "WhyChooseheading": "Easy Booking and Live Ride Management",
        "WhyChoosedescription": "Our smart booking system makes it easy for HR and admin teams to schedule rides, monitor trip status, and handle multiple locations across Pune. Get real-time driver and vehicle updates, route tracking, and on-demand service modifications—right at your fingertips."
    },
    {
        "WhyChooseheading": "Customized Corporate Travel Packages",
        "WhyChoosedescription": "No two companies are alike, and neither are their travel needs. Whether you require daily employee shuttles, airport transfers, intercity meetings, or transport for a corporate offsite, eTravo offers tailored packages designed around your company’s specific operational demands in Pune."
    }
]




























    }

// Corporate Cab and Bus Services in Pune – eTravo

const faqData = [
    [
        {
            question: 'What corporate transportation services does eTravo provide in Pune?',
            answer: 'eTravo offers full-scale corporate cab and bus services in Pune, including daily employee transport, executive car rentals, event transfers, airport pickups, and intercity business travel.',
        },
        {
            question: 'Can eTravo support shift-based employee commutes across Pune?',
            answer: 'Yes, we specialize in managing transportation for companies operating in multiple shifts, with route optimization, real-time tracking, and on-time pickups across Pune’s business hubs and industrial zones.',
        },
        {
            question: 'What vehicle options are available for corporate use in Pune?',
            answer: 'Our fleet includes well-maintained sedans, hatchbacks, SUVs, tempo travellers, and air-conditioned buses ranging from 13 to 50 seats — all suitable for daily commutes and executive transport.',
        },
        {
            question: 'Are safety and tracking features included in the service?',
            answer: 'Absolutely. eTravo ensures GPS-enabled tracking, verified driver profiles, route monitoring, and automated trip logs — helping companies maintain safety, accountability, and compliance.',
        },
        {
            question: 'Does eTravo provide transport for corporate events and offsites in Pune?',
            answer: 'Yes, we offer flexible booking for townhalls, team outings, conferences, and offsite travel. Our coordination team ensures timely vehicle deployment and smooth travel for all participants.',
        },
        {
            question: 'Do corporate clients in Pune get a dedicated support manager?',
            answer: 'Yes, each corporate client is assigned a dedicated account manager for handling scheduling, reporting, invoicing, service quality monitoring, and support requests.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Kamat',
        designation: 'Operations Head, BlueMatrix Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo for over two years for our Pune operations. Their service is extremely reliable, drivers are courteous, and the tracking system is top-notch.”',
    },
    {
        name: 'Ms. Shweta Joshi',
        designation: 'HR Manager, DigiSpace Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has streamlined our employee commute in Pune. Their support team is responsive, and vehicle quality is consistently excellent. Highly recommended for corporate travel.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-pune.jpg",
  "description": "Book reliable corporate cab and bus services in Pune with eTravo. Ideal for office transport, employee shuttles, business event transportation, and daily corporate commutes with affordable AC vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Corporate Cab and Bus Services in Pune | Employee Shuttle & Office Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Pune with eTravo for office transport, employee shuttles, business events, and daily commutes. Affordable and reliable AC cabs and buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinpune;